<template>
  <div class="widget" v-bind:class="[{'loaded':loaded},className]" v-if="$aclInterfaceValidator('weeboxshop.order.statsca')">

    <header class="widget-header">
      <h2 class="widget-title">{{ title }}</h2>
      <h3 class="widget-title-period">
        <span v-for="item in periods" v-if="item.id == period">{{ item.label }}</span>
      </h3>

      <div class="widget-actions-container">
        <div><form-toggle label="" v-model="is_ttc" label-true="TTC" label-false="HT"></form-toggle></div>
        <widget-dropdown v-model="period" :options="periods" :callback="filterByPeriod"></widget-dropdown>
      </div>

      <div class="form-advanced-filter" v-if="showAdvancedFilterVue">
        <span>Filtrer par date</span>
        <div class="date-filters">
          <form-datetime label="du" v-model="dateFilter.start_at" :hide-time="true" time="00:00:00"></form-datetime>
          <form-datetime label="au" v-model="dateFilter.end_at" :hide-time="true" time="23:59:59"></form-datetime>
        </div>
      </div>


    </header>

    <div class="widget-preloader">
      <div class="pre-loader">
        <div class="box1"></div>
        <div class="box2"></div>
        <div class="box3"></div>
        <div class="box4"></div>
        <div class="box5"></div>
      </div>
    </div>

    <div class="widget-content" v-if="stats.dataset">
      <div class="widget-content-datas">
        <div class="data-labels">

          <div class="data-label" v-if="is_ttc">
            <strong><i class="currency">{{ currency }}<span>TTC</span></i> {{ total|formatNumber }}</strong>
            <span class="compare-to-previous">
                      <compare :previous="total_compare" :current="total" :currency="currency"></compare>
                    </span>
            <span class="legend">Total TTC</span>
          </div>

          <div class="data-label" v-if="!is_ttc">
            <strong><i class="currency">{{ currency }}<span>HT</span></i> {{ total_ht|formatNumber }}</strong>
            <span class="compare-to-previous">
                      <compare :previous="total_compare_ht" :current="total_ht" :currency="currency"></compare>
                    </span>
            <span class="legend">Total HT</span>
          </div>

          <div class="data-label" v-if="is_ttc">
            <strong><i class="currency">{{ currency }}<span>TTC</span></i> {{ total/count|formatNumber }}</strong>
            <span class="compare-to-previous">
                          <compare :previous="(total_compare/count_compare)" :current="(total/count)" :currency="currency"></compare>
                        </span>
            <span class="legend">Panier moyen TTC</span>
          </div>

          <div class="data-label" v-if="!is_ttc">
            <strong><i class="currency">{{ currency }}<span>HT</span></i> {{ total_ht/count|formatNumber }}</strong>
            <span class="compare-to-previous">
                      <compare :previous="(total_compare_ht/count_compare)" :current="(total_ht/count)" :currency="currency"></compare>
                    </span>
            <span class="legend">Panier moyen HT</span>
          </div>

          <div class="data-label">
            <strong>{{ count }}</strong>
            <span class="compare-to-previous">
                          <compare :previous="count_compare" :current="count"></compare>
                        </span>
            <span class="legend">Ventes</span>
          </div>

        </div>

      </div>

      <div class="widget-chart" v-bind:class="{'active':stats.labels.length}" @click="setChartToFull">
        <chart :dataset="stats.dataset" :labels="stats.labels" :options="options" v-if="stats"></chart>
      </div>
    </div>
  </div>
</template>
<script>

    import InvoiceService from './InvoiceService.js';
    import Bar from '../../../components/chart/Spline.vue'

    export default {
      name: 'Widget',
      components: {
        'chart' : Bar
      },
      props: ['title','period','className','branch'],
      data () {
        return {
          periods: [
            {id: 'last_7days', label: '7 derniers jours'},
            {id: 'current_month', label: 'Ce mois'},
            {id: 'last_month', label: 'Le mois dernier'},
            {id: 'since_1_month', label: '30 derniers jours'},
            {id: 'since_3_months', label: '90 derniers jours'},
            {id: 'current_year', label: 'Cette année'},
            {id: 'last_year', label: 'Depuis 12 mois'},
            {id: 'all', label: 'Tout'},
            {id: 'custom', label: 'Personnalisé'},
          ],
          forceRefresh: null,
          loaded: false,
          stats: {
            dataset: null,
            labels: null
          },
          dateFilter: {
            start_at: '',
            end_at: '',
          },
          showAdvancedFilterVue: false,
          count: null,
          total: null,
          currency: null,
          is_ttc: true,
          options: {
            legend: {
              labels: {
                usePointStyle: true,
                boxWidth: 6,
                fontSize: 10,
                fontFamily: 'Gotham Rounded',
                fontWeight: 300
              }
            },
            layout: {
              padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
              }
            },
            scales: {
              xAxes: [ {
                categoryPercentage: 0.9,
                barPercentage: 0.9,
                stacked: false,
                steppedLine: true,
                gridLines: {
                  offsetGridLines: false,
                  display: false,
                  color: "#eeeeee",
                  drawBorder: false
                },
                ticks: {
                  display: true,
                  fontColor: "#cccccc",
                  fontSize: 10,
                  mirror: false,
                  padding: 0,
                  align: 'start',
                  fontFamily: 'Gotham Rounded',
                  fontWeight: 300
                },
              }],
              yAxes: [ {
                stacked: false,
                steppedLine: true,
                gridLines: {
                  offsetGridLines: true,
                  display: true,
                  color: "#eeeeee",
                  borderDashOffset: 1,
                  borderDash: [2,2],
                  drawBorder: false
                },
                ticks: {
                  fontColor: "#cccccc",
                  fontSize: 10,
                  display: true,
                  padding: 0,
                  fontFamily: 'Gotham Rounded',
                  fontWeight: 300
                  //stepSize: 1,
                  //suggestedMax: 0,
                  //suggestedMin: 0
                }
              }]
            }
          }
        }
      },
      mounted: function(){
        this.currency = this.$store.state.scope.currency_id
        this.is_ttc = this.$store.state.scope.is_ttc
        this.period = this.period ? this.period : this.periods[0].id

        if(this.period == 'custom') {
          this.showAdvancedFilterVue = true
        }else{
          this.showAdvancedFilterVue = false;
        }

        this.filterByPeriod(this.period);

      },
      watch: {
        'dateFilter.start_at'(newVal, oldVal) {
          if(newVal != '' && this.dateFilter.end_at != ''){
            this.filterByPeriodAndByDate(this.period, this.dateFilter);
          }
        },
        'dateFilter.end_at'(newVal, oldVal) {
          if(newVal != '' && this.dateFilter.start_at != ''){
            this.filterByPeriodAndByDate(this.period, this.dateFilter);
          }
        }
      },
      methods: {
        setChartToFull: function()
        {
          this.options.layout.padding = {
            left: -10,
            right: 0,
            top: 0,
            bottom: -10
          };
          this.options.scales.xAxes[0].ticks.display = true;
          this.options.scales.xAxes[0].gridLines.display = true;
          this.options.scales.yAxes[0].ticks.display = true;

        },
        filterByPeriod: function(period)
        {

          if(period == 'custom') {
            this.showAdvancedFilterVue = true
          }else{
            this.showAdvancedFilterVue = false;
          }

          if(period != 'custom') {

            this.loaded = false;
            this.period = period

            InvoiceService.getStats( this.period, this.branch).then((response) => {
              this.stats.dataset = response.data.result.stats.dataset
              this.stats.labels = response.data.result.stats.labels
              this.count = response.data.result.count
              this.total = response.data.result.total
              this.count_compare = response.data.result.count_compare
              this.total_compare= response.data.result.total_compare

              this.total_ht = response.data.result.total_ht
              this.total_compare_ht = response.data.result.total_compare_ht

              this.loaded = true;
            }).catch((response) => {
              console.log("error", response);
              this.loaded = true;
            })

          }
        },
        filterByPeriodAndByDate: function(period, dateFilter)
        {
          this.loaded = false;

          this.period = period
          this.date = JSON.stringify(dateFilter);

          InvoiceService.getStats( this.period, this.branch, this.date ).then((response) => {
            this.stats.dataset = response.data.result.stats.dataset
            this.stats.labels = response.data.result.stats.labels
            this.count = response.data.result.count
            this.total = response.data.result.total
            this.count_compare = response.data.result.count_compare
            this.total_compare= response.data.result.total_compare

            this.total_ht = response.data.result.total_ht
            this.total_compare_ht = response.data.result.total_compare_ht

            this.loaded = true;
          }).catch((response) => {
            console.log("error", response);
            this.loaded = true;
          })
        }
      }
    }
</script>


// WEBPACK FOOTER //
// src/modules/invoicing/invoice/StatsWidget.vue